export default __webpack_public_path__ + "static/datelabel-dropdown-dont-2-dark-b85c2821301707166261422d55210a56336b784862f4371b4fef94879201bdfd.png";